import { useHistory } from "react-router-dom";
import appConfig from "../config/app.config";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants/app.constants";
import { ROUTES } from "../constants/routes.constants";
import useRestApiCall from "../http.interceptor";
import useFetchUserInfo from "./fetch-user-info/useFetchUserInfo";


const logoutPayload = (data,accessToken) => {
    let apiPayload = {
        method: "POST",
        data: data,
        url: "/api/auth/logout",
        baseURL: appConfig.apiMarketplaceBaseUrl,
        headers: {
            "Authorization" : `Bearer ${accessToken}` 
           }
    };
    return apiPayload;
};

const useLogout = () => {
    
    
    const { apiCall } = useRestApiCall();
    const history = useHistory();
    const { clearUserInfoState } = useFetchUserInfo();

    const logout = async () => {
        try {
            let data = {refreshToken : localStorage.getItem(REFRESH_TOKEN) };
            const accessToken = localStorage.getItem(ACCESS_TOKEN);
            const payload = logoutPayload(data,accessToken);
            const response = await apiCall(payload);
            if(response?.status === 200) {
                localStorage.removeItem(ACCESS_TOKEN);
                localStorage.removeItem(REFRESH_TOKEN);
                localStorage.removeItem("rapidoc");
                clearUserInfoState();
                history.push(ROUTES.LOGIN);
            }
            return response;
            
        } catch (error) {
            console.log(error);
           
        }
    };

   
    return { logout };
};

export default useLogout;